import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class TrackBookingRouteGuard implements CanActivate {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (isPlatformBrowser(this.platformId)) {
      const url = environment.trackUrl + '?bookingref=' + route.queryParams.ref + '&email=' + route.queryParams.email + '&referrer=bookingFunnel';

      window.location.replace(url);
      return false;
    }
  }
}
